export const PAGE_EVENT_TYPES = [
  "page_view",
  "block_impression",
  "block_action",
] as const;
export type PageEventType = (typeof PAGE_EVENT_TYPES)[number];

/** What a visitor did with a block, derived from the link they followed. */
export const PAGE_BLOCK_ACTIONS = [
  "navigate",
  "section",
  "open",
  "outbound",
  "email",
  "download",
] as const;
export type PageBlockAction = (typeof PAGE_BLOCK_ACTIONS)[number];

export const PAGE_EVENTS_MAX_BATCH = 50;

/** A visit ends after this long without activity. */
export const PAGE_VISIT_IDLE_MS = 30 * 60 * 1000;

export const PAGE_UTM_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;
